import { render, staticRenderFns } from "./StatisticsMonth.vue?vue&type=template&id=2c7106f6&"
import script from "./StatisticsMonth.vue?vue&type=script&lang=js&"
export * from "./StatisticsMonth.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsMonth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports